import React, { useEffect } from 'react';
import { LoginCallback, useOktaAuth } from '@okta/okta-react';
import { useHistory, useLocation } from 'react-router-dom';

export default function OAuthCallback() {
  const location = useLocation();
  const history = useHistory();
  const { oktaAuth } = useOktaAuth();
  const params = new URLSearchParams(location.search);
  const error = params.get('error');

  useEffect(() => {
    if (error) {
      const errorDescription = params.get('error_description');

      console.error('OAuth Error in callback:', {
        error,
        errorDescription,
        timestamp: new Date().toISOString(),
      });

      switch (error) {
        case 'access_denied':
          console.warn('User not assigned to application in Okta');
          break;
        case 'interaction_required':
          console.warn('Additional authentication required');
          break;
        case 'login_required':
          console.warn('User session expired or login required');
          break;
        case 'invalid_scope':
          console.error('Invalid OAuth scope configuration');
          break;
        default:
          console.error('Unexpected OAuth error type:', error);
      }

      try {
        oktaAuth.tokenManager.clear();
      } catch (e) {
        console.error('Failed to clear token manager:', e);
      }
      sessionStorage.setItem('oauth_error_occurred', 'true');
      sessionStorage.setItem('oauth_error_type', error);
      sessionStorage.setItem('oauth_error_time', Date.now().toString());
      history.replace('/');
    }
  }, [error, params, history, oktaAuth]);

  if (error) {
    return null;
  }

  return <LoginCallback />;
}
